import { BusinessDetails } from "../../models/business-details.models";
import { Business } from "../../models/business.model";
import { City } from "../../models/city.models";
import { ContactDetails } from "../../models/contact-details.model";
import { InsureItems } from "../../models/insure-items.model";
import { InvestmentDetails } from "../../models/InvestmentDetails.model";
import { PersonalDetails } from "../../models/personal-details.model";
import { AllAPIResponseStatus } from "../../models/util.model";

export interface SharedState {
    all_api_response_status: AllAPIResponseStatus,
    enquiry_id?: string,
    loading: boolean,
    quote_data: {
        contact_details: ContactDetails,
        personal_details: PersonalDetails,
        investment_details: InvestmentDetails,
        addons: []
    }
    proposal_data: any
}

export const initialState: SharedState = {
    all_api_response_status: {
        get_pre_quote_data: true,
        save_pre_quote_data: true,
        update_pre_quote_data: true,
        select_premium: true,
    },
    enquiry_id: undefined,
    loading: false,
    quote_data: {
        contact_details: {
            name: "",
            date_of_birth: new Date(),
            gender: "",
            mobile_no: "",
            email_id: ""
        },

        personal_details: {
            occupation: "",
            occupation_id: 0,
            annual_income: 0,
        },
        investment_details: {
            investment_amount: 0,
            sum_assured: 0,
            maturity_after: 0,
            payment_period: 0,
            payment_mode: ""
        },
        addons: []
    },
    proposal_data: null
}